// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ajax from './tools/fetch'
import cr from './components/cr.vue'
import 'reset.css'

Vue.config.productionTip = false
Vue.prototype.$ajax = ajax
Vue.component('cr',cr)
if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
  window.location.href = "http://www.spacecode.com.cn/lab-h5/";
} 
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js